import { ArtAssetType } from '@do/models';

import type { Option, ValuesOf } from '@shared/types';

export const ArtworkViewMode = {
  All: 'all',
  OnSale: 'on_sale,on_auction',
  Sold: 'sold',
} as const;
export type ArtworkViewMode = ValuesOf<typeof ArtworkViewMode>;

export const ArtAssetTypeOptions = [
  {
    text: 'All',
    value: `${ArtAssetType.DigitalCommon},${ArtAssetType.DigitalOriginal}`,
  },
  {
    text: 'Digital Native',
    value: ArtAssetType.DigitalCommon,
    icon: 'digital-native',
  },
  {
    text: 'Digital Original',
    value: ArtAssetType.DigitalOriginal,
    icon: 'do',
  },
] satisfies Option[];

export const artworksViewOptions = [
  {
    text: 'All',
    value: ArtworkViewMode.All,
  },
  {
    text: 'On Sale',
    value: ArtworkViewMode.OnSale,
  },
  {
    text: 'Sold',
    value: ArtworkViewMode.Sold,
  },
] satisfies Option[];
